import React, { useEffect, useState } from "react";

import {
  Container,
  Typography
} from "@mui/material";

import {
  useParams,
  useNavigate
} from "react-router-dom";

import { toast } from "react-toastify";

import config from "../../config";

import "bootstrap/dist/css/bootstrap.css";

function ViewRepoChecklist() {

  const { repoId } = useParams();
  const decodedRepoId = repoId ? atob(repoId) : "";

  const navigate = useNavigate();

  const [data, setData] = useState(null);

const VehiclePhotoGallery = ({ photos }) => {
  const [lightboxIndex, setLightboxIndex] = useState(null);

  const openLightbox = (index) => setLightboxIndex(index);
  const closeLightbox = () => setLightboxIndex(null);

  const goPrev = () =>
    setLightboxIndex((prev) => (prev - 1 + photos.length) % photos.length);

  const goNext = () =>
    setLightboxIndex((prev) => (prev + 1) % photos.length);

  return (
    <>
      {/* Thumbnails */}
      <div className="d-flex flex-wrap gap-2">
        {photos.map((photo, index) => (
          <button
            key={index}
            type="button"
            onClick={() => openLightbox(index)}
            style={{
              padding: 0,
              border: "2px solid #dee2e6",
              borderRadius: 8,
              background: "none",
              cursor: "pointer",
              transition: "transform 0.2s",
              display: "inline-block"
            }}
            onMouseOver={(e) => { e.currentTarget.style.transform = "scale(1.08)"; }}
            onMouseOut={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
            onFocus={(e) => { e.currentTarget.style.transform = "scale(1.08)"; }}
            onBlur={(e) => { e.currentTarget.style.transform = "scale(1)"; }}
          >
            <img
              src={`${config.API_BASE_URL}${photo}`}
              alt={`Vehicle ${index + 1}`}
              style={{
                width: 80,
                height: 80,
                objectFit: "cover",
                borderRadius: 6,
                display: "block"
              }}
            />
          </button>
        ))}
      </div>

      {/* Lightbox Modal */}
      {lightboxIndex !== null && (
        <div
          role="dialog"
          aria-modal="true"
          style={{
            position: "fixed",
            top: 0, left: 0,
            width: "100%", height: "100%",
            background: "rgba(0,0,0,0.88)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          {/* Close */}
          <button
            type="button"
            onClick={closeLightbox}
            style={{
              position: "absolute",
              top: 18, right: 24,
              background: "none",
              border: "none",
              color: "#fff",
              fontSize: 32,
              cursor: "pointer",
              zIndex: 10000
            }}
          >
            ✕
          </button>

          {/* Prev */}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); goPrev(); }}
            style={{
              position: "absolute",
              left: 20,
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "#fff",
              fontSize: 28,
              borderRadius: "50%",
              width: 48, height: 48,
              cursor: "pointer",
              zIndex: 10000
            }}
          >
            ‹
          </button>

          {/* Image */}
          <img
            src={`${config.API_BASE_URL}${photos[lightboxIndex]}`}
            alt={`Vehicle ${lightboxIndex + 1}`}
            style={{
              maxHeight: "85vh",
              maxWidth: "90vw",
              borderRadius: 10,
              boxShadow: "0 8px 40px rgba(0,0,0,0.6)"
            }}
          />

          {/* Next */}
          <button
            type="button"
            onClick={(e) => { e.stopPropagation(); goNext(); }}
            style={{
              position: "absolute",
              right: 20,
              background: "rgba(255,255,255,0.15)",
              border: "none",
              color: "#fff",
              fontSize: 28,
              borderRadius: "50%",
              width: 48, height: 48,
              cursor: "pointer",
              zIndex: 10000
            }}
          >
            ›
          </button>

          {/* Counter */}
          <div
            style={{
              position: "absolute",
              bottom: 20,
              color: "#fff",
              fontSize: 14,
              fontWeight: 600,
              background: "rgba(0,0,0,0.4)",
              padding: "4px 14px",
              borderRadius: 20
            }}
          >
            {lightboxIndex + 1} / {photos.length}
          </div>
        </div>
      )}
    </>
  );
};

  const fetchData = async () => {

    try {

      const res = await fetch(
        `${config.API_BASE_URL}getRepoChecklistDetails/${decodedRepoId}`
      );

      const result = await res.json();

      console.log(result);

      if (result.status) {

        setData(result.data);

      } else {

        toast.error(result.message);

      }

    } catch {

      toast.error("Failed to load checklist");

    }

  };

  useEffect(() => {

    fetchData();

  }, []);

  if (!data) {

  return (

    <div
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(255,255,255,0.65)",
        backdropFilter: "blur(2px)",
        WebkitBackdropFilter: "blur(2px)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 99999
      }}
    >

      <div style={{ textAlign: "center" }}>

        <div
          style={{
            width: "55px",
            height: "55px",
            border: "5px solid #e5e7eb",
            borderTop: "5px solid #4f46e5",
            borderRadius: "50%",
            animation: "spin 0.8s linear infinite",
            margin: "0 auto"
          }}
        />

        <div
          style={{
            marginTop: "15px",
            fontSize: "15px",
            fontWeight: "500",
            color: "#444"
          }}
        >
          Loading...
        </div>

      </div>

      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>

    </div>

  );

}

  const renderValue = (value) => {

    if (
      value === null ||
      value === undefined ||
      value === ""
    ) {

      return "-";

    }

    if (Array.isArray(value)) {

      return value.join(", ");

    }

    return value;

  };

  return (

    <Container maxWidth="xl" className="mt-4 mb-5">

      <div className="d-flex justify-content-between align-items-center mb-4">

        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#1f2937"
          }}
        >
          View Repo Checklist
        </Typography>

      {/* // NEW */}
      {data.checklist_status === "draft" && (
        <button
          className="btn btn-warning fw-bold px-4"
          onClick={() =>
            navigate(
              `/dashboard/repo-conditions-checklist/${btoa(decodedRepoId)}`
            )
          }
        >
          EDIT CHECKLIST
        </button>
      )}

      </div>

      <div
        className="card border-0 shadow-sm"
        style={{
          borderRadius: "14px"
        }}
      >

        <div className="card-body p-0">

          <div className="table-responsive">

            <table className="table table-bordered align-middle mb-0">

              <thead
                style={{
                  background: "#eef2ff"
                }}
              >
                <tr>

                  <th
                    style={{
                      width: "30%",
                      padding: "14px",
                      fontWeight: "700"
                    }}
                  >
                    Field
                  </th>

                  <th
                    style={{
                      padding: "14px",
                      fontWeight: "700"
                    }}
                  >
                    Value
                  </th>

                </tr>
              </thead>

              <tbody>

                <tr>
                  <td className="fw-bold">Repo ID</td>
                  <td>{renderValue(data.repo_id)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Overall Vehicle Condition
                  </td>
                  <td>
                    {renderValue(data.overall_vehicle_condition)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Detailed Condition Notes
                  </td>
                  <td>
                    {renderValue(data.detailed_condition_notes)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Documentation Checklist
                  </td>
                 <td>

                    {

                      (() => {

                        try {

                          const docs = JSON.parse(
                            data.documentation_checklist || "[]"
                          );

                          if (
                            !Array.isArray(docs)
                          ) {

                            return "-";

                          }

                          return docs.join(", ");

                        } catch {

                          return "-";

                        }

                      })()

                    }

                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Vehicle Photos</td>
                  <td>
                    {(() => {
                      try {
                        console.log("RAW vehicle_photos:", data.vehicle_photos); // <-- check karo
                        const photos = JSON.parse(data.vehicle_photos || "[]");
                        console.log("PARSED photos:", photos);
                        if (!Array.isArray(photos) || photos.length === 0) return "NO PHOTOS";

                        return (
                          <VehiclePhotoGallery photos={photos} />
                        );
                      } catch (err) {
                        console.error("Parse error:", err);
                        return "PARSE ERROR";
                      }
                    })()}
                  </td>
                </tr>
                <tr>
                  <td className="fw-bold">
                    Supporting Documents
                  </td>
                  <td>

  {

    (() => {

      try {

        const docs = JSON.parse(
          data.supporting_documents || "{}"
        );

        if (
          !docs ||
          Object.keys(docs).length === 0
        ) {

          return "-";

        }

        const handleDownloadDocument = (
          filePath
        ) => {

          if (!filePath) {

            toast.error(
              "Document not available"
            );

            return;

          }

          const link =
            document.createElement("a");

          link.href =
            `${config.API_BASE_URL}${filePath}`;

          link.setAttribute(
            "download",
            filePath.split("/").pop()
          );

          document.body.appendChild(link);

          link.click();

          document.body.removeChild(link);

        };

        return Object.entries(docs).map(
          ([docName, filePath], index) => (

            <button
              key={index}
              className="
                btn
                btn-sm
                btn-info
                me-2
                mb-2
              "
              onClick={() =>
                handleDownloadDocument(
                  filePath
                )
              }
            >
              ⬇ Download {docName}
            </button>

          )
        );

      } catch {

        return "-";

      }

    })()

  }

</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Place Of Repossession
                  </td>
                  <td>
                    {renderValue(data.place_of_repossession)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">RC Book</td>
                  <td>{renderValue(data.rc_book)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">TC Book</td>
                  <td>{renderValue(data.tc_book)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Insurance Certificate
                  </td>
                  <td>
                    {renderValue(data.insurance_certificate)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Permit</td>
                  <td>{renderValue(data.permit)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Fitness Report
                  </td>
                  <td>{renderValue(data.fitness_report)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Tarpaulin</td>
                  <td>{renderValue(data.tarpaulin)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Tool Kit</td>
                  <td>{renderValue(data.tool_kit)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Radio Stereo
                  </td>
                  <td>{renderValue(data.radio_stereo)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rope / Rassi
                  </td>
                  <td>{renderValue(data.rope_rassi)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Battery Make Number
                  </td>
                  <td>
                    {renderValue(data.battery_make_number)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Electric</td>
                  <td>{renderValue(data.electric)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Number Of Wheels
                  </td>
                  <td>
                    {renderValue(data.number_of_wheels)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Vehicle Condition
                  </td>
                  <td>
                    {renderValue(data.vehicle_condition)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Jack Available
                  </td>
                  <td>
                    {renderValue(data.jack_available)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rod Available
                  </td>
                  <td>
                    {renderValue(data.rod_available)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Pana Available
                  </td>
                  <td>
                    {renderValue(data.pana_available)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Tyre Report
                  </td>
                  <td>{renderValue(data.tyre_report)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Battery No</td>
                  <td>{renderValue(data.battery_no)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Controller No
                  </td>
                  <td>{renderValue(data.controller_no)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Charger No
                  </td>
                  <td>{renderValue(data.charger_no)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Left Side
                  </td>
                  <td>
                    {renderValue(data.front_left_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Left Tyre Make
                  </td>
                  <td>
                    {renderValue(data.front_left_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Right Side
                  </td>
                  <td>
                    {renderValue(data.front_right_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Front Right Tyre Make
                  </td>
                  <td>
                    {renderValue(data.front_right_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Left Side
                  </td>
                  <td>
                    {renderValue(data.rear_left_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Left Tyre Make
                  </td>
                  <td>
                    {renderValue(data.rear_left_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Right Side
                  </td>
                  <td>
                    {renderValue(data.rear_right_side)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Right Tyre Make
                  </td>
                  <td>
                    {renderValue(data.rear_right_tyre_make)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Right Side Mirror
                  </td>
                  <td>
                    {renderValue(data.right_side_mirror)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Rear Mirror
                  </td>
                  <td>
                    {renderValue(data.rear_mirror)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Left Side Mirror
                  </td>
                  <td>
                    {renderValue(data.left_side_mirror)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Spare Tyre
                  </td>
                  <td>
                    {renderValue(data.spare_tyre)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Spare Tyre Make
                  </td>
                  <td>
                    {renderValue(data.spare_tyre_make)}
                  </td>
                </tr>

                <tr>
                    <td className="fw-bold">
                      Repair Required For Sale
                    </td>
                    <td>
                      {renderValue(data.repair_required_for_sale)}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-bold">
                      Repair Type
                    </td>
                    <td>
                      {renderValue(data.repair_type)}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-bold">
                      Vehicle Saleable
                    </td>
                    <td>
                      {renderValue(data.vehicle_saleable)}
                    </td>
                  </tr>

                  <tr>
                      <td className="fw-bold">
                        RTO Charges
                      </td>
                      <td>
                        {renderValue(data.rto_charges)}
                      </td>
                    </tr>

                    {
                      data.rto_charges === "Yes" && (
                        <tr>
                          <td className="fw-bold">
                            RTO Charges Borne By
                          </td>
                          <td>
                            {renderValue(data.rto_charges_by)}
                          </td>
                        </tr>
                      )
                    }

                    <tr>
                      <td className="fw-bold">
                        Challan Status
                      </td>
                      <td>
                        {renderValue(data.challan_status)}
                      </td>
                    </tr>

                    {
                      data.challan_status === "Yes" && (
                        <tr>
                          <td className="fw-bold">
                            Challan Amount
                          </td>
                          <td>
                            {renderValue(data.challan_amount)}
                          </td>
                        </tr>
                      )
                    }

                    <tr>
                      <td className="fw-bold">
                        Insurance Validity
                      </td>
                      <td>
                        {renderValue(data.insurance_validity)}
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-bold">
                        Fitness Validity
                      </td>
                      <td>
                        {renderValue(data.fitness_validity)}
                      </td>
                    </tr>

                    <tr>
                      <td className="fw-bold">
                        Other Expenses
                      </td>
                      <td>
                        {renderValue(data.other_expenses)}
                      </td>
                    </tr>

                    {
                      data.other_expenses === "Yes" && (
                        <tr>
                          <td className="fw-bold">
                            Other Expenses Amount
                          </td>
                          <td>
                            {renderValue(data.other_expenses_amount)}
                          </td>
                        </tr>
                      )
                    }

                    <tr>
                      <td className="fw-bold">
                        Has We Sent For Repair
                      </td>
                      <td>
                        {renderValue(data.has_we_sent_for_repair)}
                      </td>
                    </tr>

                    {
                      data.has_we_sent_for_repair === "Yes" && (
                        <tr>
                          <td className="fw-bold">
                            Repair Sent Date
                          </td>
                          <td>
                            {renderValue(data.repair_sent_date)}
                          </td>
                        </tr>
                      )
                    }

                  <tr>
                    <td className="fw-bold">
                      Inspection Date
                    </td>
                    <td>
                      {renderValue(data.inspection_date)}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-bold">
                      Police Station Address
                    </td>
                    <td>
                      {renderValue(data.police_station_number)}
                    </td>
                  </tr>

                  <tr>
                    <td className="fw-bold">
                      Receiver Name
                    </td>
                    <td>
                      {renderValue(data.receiver_name)}
                    </td>
                  </tr>

                <tr>
                  <td className="fw-bold">
                    Additional Information
                  </td>
                  <td>
                    {renderValue(data.additional_information)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Checklist Status
                  </td>
                  <td>
                    {renderValue(data.checklist_status)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">Latitude</td>
                  <td>{renderValue(data.latitude)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">Longitude</td>
                  <td>{renderValue(data.longitude)}</td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Location Address
                  </td>
                  <td>
                    {renderValue(data.location_address)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Attempt Count
                  </td>
                  <td>
                    {renderValue(data.attempt_count)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Created By
                  </td>

                  <td>
                    {renderValue(data.created_by_name)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Updated By
                  </td>

                  <td>
                    {renderValue(data.updated_by_name)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Created At
                  </td>

                  <td>
                    {renderValue(data.created_at)}
                  </td>
                </tr>

                <tr>
                  <td className="fw-bold">
                    Updated At
                  </td>

                  <td>
                    {renderValue(data.updated_at)}
                  </td>
                </tr>

              </tbody>

            </table>

          </div>

        </div>

      </div>

    </Container>

  );

}

export default ViewRepoChecklist;